import { DOAbnormalOperationUserBean } from "./do-abnormal-operation-user-bean";
export class DOAbnormalMailRequest extends DOAbnormalOperationUserBean {
  doNos: string[];
  moNos: string[];
  facilities: string[];

  constructor() {
    super()
    this.doNos = [];
    this.moNos = [];
    this.facilities = [];
  }
}
